// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
export var SampleRate = "sampleRate";
export var ProcessLegacy = "ProcessLegacy";
export var HttpMethod = "http.method";
export var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
//# sourceMappingURL=Constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-common/dist-esm/Constants.js
// module id = 222
// module chunks = 42